import { render, staticRenderFns } from "./faceEdit.vue?vue&type=template&id=9b3f6c7a&scoped=true&"
import script from "./faceEdit.vue?vue&type=script&lang=js&"
export * from "./faceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3f6c7a",
  null
  
)

export default component.exports